import { render } from "./Paralax.vue?vue&type=template&id=00bde6df"
import script from "./Paralax.vue?vue&type=script&lang=js"
export * from "./Paralax.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__